var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"item",on:{"click":_vm.handleClick}},[(_vm.item.icon)?_c('div',{staticClass:"item-icon"},[_c('AppIcon',{attrs:{"name":_vm.item.icon,"type":_vm.item.iconType}})],1):_vm._e(),_c('span',{staticClass:"item-label"},[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }